import React from 'react'
import { useTranslation } from 'react-i18next'

import ProgramDeadlines from './ProgramDeadlines'

const FunderProgramDescription = ({ funderProgram }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  return (
    <div className="profile-programs-description">
      {funderProgram.description && (
        <div dangerouslySetInnerHTML={{ __html: funderProgram.description }} />
      )}
      <div className="extra_contact">
        {funderProgram.programContacts?.map((contact, index) => (
          <div key={index}>
            <h4>{t.funder.programContact}</h4>
            <div dangerouslySetInnerHTML={{ __html: contact.name }} />
          </div>
        ))}
      </div>
      <ProgramDeadlines funderProgram={funderProgram} />
    </div>
  )
}

export default FunderProgramDescription
